<p-confirmDialog key="emailConfigSteps" #cd [style]="{'max-width': '60vw', 'width': '60vw'}" styleClass="custom-confirm-dialog" appendTo="body">
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
      <div
        class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg animate-bounce-in">
        <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
      </div>
      <div class="mt-16 text-center w-full">
        <h3 class="text-2xl font-bold text-gray-900 mb-3">
          {{ message.header }}
        </h3>
        <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
          {{ message.message }}
        </p>
        <div *ngIf="message.key === 'emailConfigSteps'" class="text-left bg-gray-50 rounded-lg p-5 mx-auto max-w-xl mb-6">
          <div class="space-y-3">
            <div class="flex items-start gap-3">
              <div class="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-semibold flex-shrink-0">1</div>
              <div class="pt-1">
                <p class="font-semibold text-gray-900">Connect Your Domain</p>
                <p class="text-sm text-gray-600 -mt-1">Navigate to Configuration Panel and connect your domain.</p>
              </div>
            </div>
            <div class="flex items-start gap-3">
              <div class="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-semibold flex-shrink-0">2</div>
              <div class="pt-1">
                <p class="font-semibold text-gray-900">Create Email Address</p>
                <p class="text-sm text-gray-600">Create a dedicated email address (e.g., credentials&#64;gravitas.ai) for sending student credentials.</p>
              </div>
            </div>
            <div class="flex items-start gap-3">
              <div class="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-semibold flex-shrink-0">3</div>
              <div class="pt-1">
                <p class="font-semibold text-gray-900">Map Email in Module Settings</p>
                <p class="text-sm text-gray-600">Go to Module Mapping section and assign the email to send profile credentials to students.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center gap-3 mt-6">
          <button *ngIf="message.rejectVisible !== false" pButton type="button"
            [label]="message.rejectLabel || 'Cancel'" (click)="message.reject && message.reject()"
            class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
          </button>
          <button pButton type="button" [label]="message.acceptLabel || 'Yes, Continue'"
            (click)="message.accept && message.accept()"
            class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:-translate-y-0.5">
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<div class="rounded-xl overflow-hidden shadow-lg">

  <!-- Header -->
  <div class="flex items-center justify-center dialog-header">
    Create Student Profile
    <div class="absolute right-4">
      <button (click)="handleCloseDialog()" class="text-white hover:text-gray-300">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="dialog-content p-6 text-center">
    <!-- User Icon -->
    <i class="pi pi-user-plus text-gray-600 mb-4" style="font-size: 27px;"></i>

    <!-- Title -->
    <div class="font-semibold text-xl mb-2">
      Are you sure you want to create student profile?
    </div>

    <!-- Student Info -->
    <div class="text-gray-600 mb-4">
      <strong>Name:</strong> {{ getFullName(editLeadData) }}<br />
      <strong>Email:</strong> {{ editLeadData?.email || 'N/A' }}
    </div>

    <!-- Buttons -->
    <div class="flex gap-4 justify-center mt-6">
      <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()">
      </p-button>

      <p-button label="Generate" icon="pi pi-check" 
                (click)="handleGenerateProfile()" [disabled]="isLoading" [loading]="isLoading">
      </p-button>
    </div>
  </div>
</div>
